<div class="table-container">

  <div class="table-filter" style="display: inline-block">
    <label id="filter-label" for="filter-input" i18n="@@adduserdeviceslist_filter">Filtra: </label>
    <input id="filter-input" (keyup)="onKey($event)" />
  </div>

  <table mat-table matSort #deviceslisttable class="simple-table">
    <!--matSortActive="checkbox" matSortDirection="asc" -->

    <!-- check Column -->
    <ng-container matColumnDef="checkbox">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let device let i=index" style="width: 5%;">
        <mat-checkbox (change)=addSelectedDevice(device) [disabled]="groupSelected || !canUserEdit" [checked]=device.selected>
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="serial">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@adduserdeviceslist_tableHeader_serial"
        style="width: 25%;">Seriale</th>
      <td mat-cell *matCellDef="let device"> {{ device.serial }} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@adduserdeviceslist_tableHeader_description"
        style="width: 25%;">Descrizione</th>
      <td mat-cell *matCellDef="let device"> {{ device.name }} </td>
    </ng-container>

    <ng-container matColumnDef="permissions">
      <th mat-header-cell *matHeaderCellDef i18n="@@adduserdeviceslist_tableHeader_permission" style="width: 50%;">
        Permessi</th>
      <td mat-cell *matCellDef="let device"> {{ device.shortPermissions }}
        <fa-icon *ngIf="hasExpiredPermissions(device) && device.selected" icon="exclamation-circle"
          style="color:red; margin-left: 10px;">
        </fa-icon>
      </td>
    </ng-container>

    <!-- Modify Column -->
    <ng-container matColumnDef="modifyPermissions">
      <th mat-header-cell *matHeaderCellDef i18n="@@adduserdeviceslist_tableHeader_modify" style="width: 5%;"> </th>
      <td mat-cell *matCellDef="let device">
        <fa-icon *ngIf="!groupSelected && canUserEdit" icon="edit" class="float-right padding-5 icon-clickable"
          (click)="modifyPermissions(device)"></fa-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>

</div>

<app-loading-screen #deviceslistloader></app-loading-screen>
